import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _contentVariantStyles;

import { css } from 'styled-components';
import { typographyBody1, typographyBody2, typographyButton, typographyCaption, typographyLink, typographyOverline, typographyLink2 } from "../../core";
import { CONTENT_TYPES } from "../constants";
export var contentVariantStyles = (_contentVariantStyles = {}, _defineProperty(_contentVariantStyles, CONTENT_TYPES.BODY_1, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref) {
  var theme = _ref.theme;
  return typographyBody1(theme);
})), _defineProperty(_contentVariantStyles, CONTENT_TYPES.BODY_2, css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return typographyBody2(theme);
})), _defineProperty(_contentVariantStyles, CONTENT_TYPES.BUTTON, css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref3) {
  var theme = _ref3.theme;
  return typographyButton(theme);
})), _defineProperty(_contentVariantStyles, CONTENT_TYPES.CAPTION, css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref4) {
  var theme = _ref4.theme;
  return typographyCaption(theme);
})), _defineProperty(_contentVariantStyles, CONTENT_TYPES.OVERLINE, css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref5) {
  var theme = _ref5.theme;
  return typographyOverline(theme);
})), _defineProperty(_contentVariantStyles, CONTENT_TYPES.TEXT_LINK, css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref6) {
  var theme = _ref6.theme;
  return typographyLink(theme);
})), _defineProperty(_contentVariantStyles, CONTENT_TYPES.TEXT_LINK_2, css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref7) {
  var theme = _ref7.theme;
  return typographyLink2(theme);
})), _contentVariantStyles);